export default {"src":"/_next/static/media/secured-by-razorpay.bae90646.svg","height":19,"width":145,"blurWidth":0,"blurHeight":0};